<template>
  <div class="upload-v2">
    <el-upload
      action="#"
      :multiple="false"
      :auto-upload="false"
      :show-file-list="false"
      :disabled="disabled"
      :file-list="fileList"
      :accept="accept"
      :on-change="changeHandler">
      <div class="upload-box">
        <span class="iconfont icon-a-hebingxingzhuangbeifen8"></span>
        <span class="title">{{title || $t('message.common.uploadFile')}}</span>
        <span class="iconfont icon-a-fenzu16beifen8"></span>
      </div>
    </el-upload>
    <template v-if="fileList.length > 0">
      <div v-for="(item, index) in fileList" :key="index" class="file-list">
        <div class="file-item">
          <span class="thumbnail-box">
            <template v-if="getFileType(item.name) === 'excel'">
              <span class="thumbnail-icon-box">
                <span class="iconfont icon-excl thumbnail" style="color: #79CF64;"></span>
              </span>
            </template>
            <template v-else-if="getFileType(item.name) === 'word'">
              <span class="thumbnail-icon-box">
                <span class="iconfont icon-word thumbnail" style="color: #264373;"></span>
              </span>
            </template>
            <template v-else-if="getFileType(item.name) === 'image'">
              <el-image :ref="`thumbnail${index}`" class="thumbnail-img" fit="cover" :src="item.url" :preview-src-list="[item.url]"></el-image>
            </template>
            <template v-else>
              <span class="thumbnail-icon-box">
                <span class="iconfont icon-other1 thumbnail"></span>
              </span>
            </template>
          </span>
          <span class="file-name">{{item.name}}</span>
          <span v-if="!disabled" class="iconfont icon-a-shanchubeifen2" @click="removeHandler(item, index)"></span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    fileList: { // 已上传文件列表
      type: Array,
      default: () => [], // {name, url, size}
    },
    onChange: {
      type: Function,
      default: null,
    },
    onRemove: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      fileTypes: {
        excel: ['csv', 'xls', 'xlsx'],
        word: ['doc', 'docx'],
        image: ['jpg', 'png', 'gif', 'bmp', 'jpeg'],
      },
    };
  },
  methods: {
    changeHandler(file, fileList) {
      if (this.onChange) {
        this.onChange(file, fileList);
      }
    },
    removeHandler(file, index) {
      if (this.onRemove) {
        this.onRemove(file, index);
      }
    },
    getFileType(fileName) {
      const fileNameArr = fileName.split('.');
      const ext = fileNameArr[fileNameArr.length - 1].toLowerCase();
      if (this.fileTypes.excel.indexOf(ext) > -1) {
        return 'excel';
      }
      if (this.fileTypes.word.indexOf(ext) > -1) {
        return 'word';
      }
      if (this.fileTypes.image.indexOf(ext) > -1) {
        return 'image';
      }
      return '';
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/element-variables.scss';
.upload-v2 {
  width: 100%;
  .upload-box {
    display: flex;
    align-items: center;
    width: 100%;
    height: 44px;
    background: $color-default;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    color: $color-text-primary;
    line-height: 20px;
    padding: 0 15px;
    box-sizing: border-box;

    .title {
      flex: 1;
      text-align: left;
      margin-left: 14px;
    }
  }

  .file-list {
    .file-item {
      margin-top: 6px;
      width: 100%;
      height: 44px;
      background: $color-default;
      border-radius: 4px;
      padding: 0 15px;
      box-sizing: border-box;
      display: flex;
      align-items: center;

      .thumbnail-box {
        display: inline-block;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        text-align: center;
        position: relative;
        margin-right: 18px;
        .thumbnail-icon-box {
          display: inline-block;
          background: $color-default;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          position: relative;
        }
        .thumbnail-img {
          width: 36px;
          height: 36px;
          pointer-events: none;
        }
        .thumbnail {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          font-size: 33px;
        }
      }

      .file-name {
        flex: 1;
        font-size: 12px;
        font-weight: 400;
        color: $color-text-primary;
        line-height: 15px;
      }

      .iconfont {
        cursor: pointer;
      }
    }
  }
}
</style>
